module.exports = __webpack_public_path__ + "static/media/brand-promotion-desktop-gendai.711c2286.png";